import { getDBAsync } from '@/db';
import type { Player, Team, Match, Game, Round } from '@/types';

export interface ExportData {
  version: string;
  exportedAt: string;
  players: Player[];
  teams: Team[];
  matches: Match[];
  games: Game[];
  rounds: Round[];
}

export async function exportAllData(): Promise<ExportData> {
  const db = await getDBAsync();

  const [players, teams, matches, games, rounds] = await Promise.all([
    db.getAll('players'),
    db.getAll('teams'),
    db.getAll('matches'),
    db.getAll('games'),
    db.getAll('rounds'),
  ]);

  return {
    version: '0.1.0',
    exportedAt: new Date().toISOString(),
    players,
    teams,
    matches,
    games,
    rounds,
  };
}

export function downloadAsJson(data: ExportData): void {
  const json = JSON.stringify(data, null, 2);
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `belot-export-${new Date().toISOString().split('T')[0]}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
